import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../../components/public/PublicLayout';
import { addLeadFs } from '../../utils/firestoreStore';

export default function StudentSignup() {
  const navigate = useNavigate();
  const useFirebase = process.env.REACT_APP_USE_FIREBASE === 'true';
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (field) => (event) => {
    setForm(prev => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);

    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError('Please complete all required fields.');
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        event: 'Passover',
        startsOn: '2026-04-01',
        endsOn: '2026-04-09',
        submittedAt: new Date().toISOString()
      };

      const existing = JSON.parse(localStorage.getItem('shem_passover_signups') || '[]');
      localStorage.setItem('shem_passover_signups', JSON.stringify([payload, ...existing]));

      if (useFirebase) {
        try {
          await addLeadFs({
            fullName: payload.name,
            email: payload.email,
            phone: payload.phone,
            stage: 'passover_signup',
            intake: 'Passover 2026',
            eventName: 'Passover'
          });
        } catch {
          // Non-blocking fallback is localStorage
        }
      }

      setSuccess(true);
      setForm({ name: '', email: '', phone: '' });
    } catch (err) {
      setError('Sign up failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PublicLayout>
      <div className="register-shell">
        <div className="register-hero">
          <div className="register-hero-content">
            <div className="register-eyebrow">School of SHEM</div>
            <h1>Passover Sign Up</h1>
            <p>Register for Passover from 01 April to 09 April and receive the event access link.</p>
            <div className="register-hero-actions">
              <button className="btn register-home-btn" style={{ background: 'white', color: 'var(--primary)' }} type="button" onClick={() => navigate('/')}>Back to Home</button>
              <button className="btn btn-secondary" type="button" onClick={() => navigate('/login')}>Login</button>
            </div>
          </div>
          <div className="register-hero-card">
            <h3>Passover Dates</h3>
            <p>Starts: 01 April 2026</p>
            <p>Ends: 09 April 2026</p>
          </div>
        </div>

        <div className="register-form-card">
          <div className="register-form-header">
            <h2>Sign Up for Passover</h2>
            <p>Name, email, and phone number are required.</p>
          </div>
          <form onSubmit={handleSubmit} className="register-form">
            <div className="register-form-grid">
              <input className="form-input" placeholder="Full Name" value={form.name} onChange={handleChange('name')} required />
              <input className="form-input" type="email" placeholder="Email" value={form.email} onChange={handleChange('email')} required />
              <input className="form-input" placeholder="Phone" value={form.phone} onChange={handleChange('phone')} required />
            </div>
            {error && <div className="badge badge-danger">{error}</div>}
            {success && (
              <div className="badge badge-success" style={{ textAlign: 'left' }}>
                Sign up successful. Your Passover registration has been received.
              </div>
            )}
            {success && (
              <div className="card" style={{ marginTop: '8px', background: 'rgba(212, 175, 55, 0.08)', border: '1px solid rgba(212, 175, 55, 0.25)' }}>
                <div className="card-body" style={{ display: 'grid', gap: '8px' }}>
                  <h3 style={{ margin: 0, fontSize: '1rem' }}>You are registered for Passover</h3>
                  <p style={{ margin: 0, color: 'var(--gray-600)' }}>
                    Thank you for signing up. We look forward to sharing this sacred season with you.
                  </p>
                  <p style={{ margin: 0, fontStyle: 'italic', color: 'var(--primary)' }}>
                    “When I see the blood, I will pass over you.” — Exodus 12:13
                  </p>
                  <div style={{ marginTop: '8px' }}>
                    <p style={{ margin: 0, color: 'var(--gray-700)' }}>
                      While you prepare for Passover, grab a book here:
                    </p>
                    <a
                      className="btn btn-outline btn-sm"
                      href="https://drtich.co.za/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginTop: '8px' }}
                    >
                      Visit drtich.co.za
                    </a>
                  </div>
                </div>
              </div>
            )}
            <div className="register-form-actions">
              <button className="btn btn-gold" type="submit" disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit Sign Up'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </PublicLayout>
  );
}
